/**
 * Composant Breadcrumb (Fil d'Ariane)
 * Navigation contextuelle accessible pour indiquer la position de l'utilisateur
 */
import { Link } from 'react-router-dom'

export interface BreadcrumbItem {
  label: string
  href?: string
  icon?: React.ReactNode
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  separator?: React.ReactNode
  className?: string
}

export default function Breadcrumb({
  items,
  separator = '/',
  className = '',
}: BreadcrumbProps) {
  if (items.length === 0) return null

  return (
    <nav aria-label="Fil d'Ariane" className={`breadcrumb ${className}`}>
      <ol className="flex items-center gap-2 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && (
              <span className="text-gray-400" aria-hidden="true">
                {separator}
              </span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-1"
              >
                {item.icon}
                {item.label}
              </Link>
            ) : (
              <span className="text-gray-900 font-medium flex items-center gap-1">
                {item.icon}
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
